;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Container = require("./saved-cards/Container.vue");

var _Container2 = _interopRequireDefault(_Container);

var _Header = require("./components/Header.vue");

var _Header2 = _interopRequireDefault(_Header);

var _Footer = require("./components/Footer.vue");

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Header: _Header2.default,
    Footer: _Footer2.default,
    Container: _Container2.default
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-12 gap-6 min-h-screen"},[_c('div',{staticClass:"col-span-full lg:col-span-7 flex justify-end"},[_c('div',{staticClass:"lg:max-w-[720px] w-full"},[_c('div',{staticClass:"flex flex-col gap-6 h-full"},[_c('div',{staticClass:"flex flex-col gap-6 h-full py-10 px-4"},[_c('Header',{attrs:{"showCards":true}}),_vm._v(" "),_c('Container')],1),_vm._v(" "),_c('Footer')],1)])]),_vm._v(" "),_vm._m(0)])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-span-full lg:col-span-5 bg-[#F7F8FC] h-full p-10"},[_c('div',{staticClass:"p-6 bg-[#ffffff] rounded-2xl flex flex-col justify-start items-start gap-[22px] min-h-[600px] max-w-[460px]"})])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c5e76e96", __vue__options__)
  } else {
    hotAPI.reload("data-v-c5e76e96", __vue__options__)
  }
})()}